exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\r\n    max-width: 400px !important;\r\n    margin: 110px auto !important;\r\n    max-height: 514px;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/modal-line/modal-line.component.css
// module id = ../../../../../src/app/components/modal-line/modal-line.component.css
// module chunks = main